export const StudentAttendanceTypeData = [
  {
    id: "AD9892434",
    key: "1",
    date: "25 Mar 2024",
    name: "Janet",
    img: "https://imageplaceholder.net/300",
    class: "III",
    dob: "10 Jan 2015",
    fname: "Mary",
    img2: "https://imageplaceholder.net/300",
    count: "22",
  },
  {
    id: "AD9892433",
    key: "2",
    date: "18 Mar 2024",
    name: "Joann",
    img: "https://imageplaceholder.net/300",
    class: "IV",
    dob: "19 Aug 2014",
    fname: "Michael",
    img2: "https://imageplaceholder.net/300",
    count: "15",
  },
  {
    id: "AD9892432",
    key: "3",
    date: "14 Mar 2024",
    name: "Kathleen",
    img: "https://imageplaceholder.net/300",
    class: "II",
    dob: "05 Dec 2017",
    fname: "Jessie",
    img2: "https://imageplaceholder.net/300",
    count: "24",
  },
  {
    id: "AD9892431",
    key: "4",
    date: "27 Feb 2024",
    name: "Gifford",
    img: "https://imageplaceholder.net/300",
    class: "I",
    dob: "22 Mar 2018",
    fname: "Robert",
    img2: "https://imageplaceholder.net/300",
    count: "22",
  },
  {
    id: "AD9892430",
    key: "5",
    date: "13 Feb 2024",
    name: "Gifford",
    img: "https://imageplaceholder.net/300",
    class: "II",
    dob: "13 May 2017",
    fname: "Colleen",
    img2: "https://imageplaceholder.net/300",
    count: "22",
  },
  {
    id: "AD9892429",
    key: "6",
    date: "11 Feb 2024",
    name: "Ralph",
    img: "https://imageplaceholder.net/300",
    class: "III",
    dob: "20 Jun 2015",
    fname: "Arthur",
    img2: "https://imageplaceholder.net/300",
    count: "24",
  },
  {
    id: "AD9892428",
    key: "7",
    date: "24 Jan 2024",
    name: "Julie",
    img: "https://imageplaceholder.net/300",
    class: "V",
    dob: "18 Sep 2013",
    fname: "Claudia",
    img2: "https://imageplaceholder.net/300",
    count: "24",
  },
  {
    id: "AD9892427",
    key: "8",
    date: "19 Jan 2024",
    name: "Ryan",
    img: "https://imageplaceholder.net/300",
    class: "VI",
    dob: "26 Nov 2012",
    fname: "Johnson",
    img2: "https://imageplaceholder.net/300",
    count: "21",
  },
  {
    id: "AD9892426",
    key: "9",
    date: "08 Jan 2024",
    name: "Susan",
    img: "https://imageplaceholder.net/300",
    class: "VIII",
    dob: "26 May 2010",
    fname: "Marquita",
    img2: "https://imageplaceholder.net/300",
    count: "24",
  },
  {
    id: "AD9892425",
    key: "10",
    date: "22 Dec 2024",
    name: "Richard",
    img: "https://imageplaceholder.net/300",
    class: "VII",
    dob: "06 Oct 2011",
    fname: "Thomas",
    img2: "https://imageplaceholder.net/300",
    count: "24",
  },
  {
    id: "AD9892424",
    key: "11",
    date: "15 Dec 2024",
    name: "Veronica",
    img: "https://imageplaceholder.net/300",
    class: "IX",
    dob: "27 Dec 2009",
    fname: "Jessie",
    img2: "https://imageplaceholder.net/300",
    count: "24",
  },
];
